export const GoogleMapApiConfig = 'AIzaSyD1ZXyzvqGPRE87w7sith9RiSyGULIdLo8';